import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import { BillingService } from "../services/billing.service";
import { IAggregatedChargeItemsInfo } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "billingFirstPeriodStart",
})
export class BillingFirstPeriodStartPipe implements PipeTransform {
  constructor(public billingService: BillingService) {}

  transform(value: IAggregatedChargeItemsInfo): string {
    let date = "";
    value.chargeItems?.forEach((chargeItem) => {
      if (!date || moment(date).isAfter(moment(chargeItem.start))) {
        date = chargeItem.start;
      }
    });
    return date;
  }
}
